import { PaginationParams } from '../types/params/request-params.interface';

export const historyQueryParams = (
  sortModel: Array<{ colId: string; sort: string }>,
  queryParams: PaginationParams
): PaginationParams => {
  const sortingByVersion =
    !sortModel[0] || sortModel[0].colId === 'versionNumber';
  const versionDirection = sortModel[0]?.sort || 'desc';
  return {
    ...queryParams,
    sort: sortingByVersion
      ? [`versionNumber,${versionDirection}`, 'createdAt,desc']
      : [`${sortModel[0].colId},${sortModel[0].sort}`],
  };
};

export const formatQueryParams = (
  sortModel: Array<{ colId: string; sort: string }>,
  queryParams: PaginationParams
) => {
  if (sortModel[0]) {
    const colId = sortModel[0].colId;
    const sort = sortModel[0].sort;
    return {
      ...queryParams,
      sort: `${colId},${sort}`,
    };
  }
  return queryParams;
};
